<template>
  <div>
    <ed-cliente :intId="0"  :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdCliente from "@/components/cliente/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdCliente },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>